import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'table-email-fields',
    templateUrl: './email-fields.component.html',
    styleUrls: ['./email-fields.component.scss'],
})
export class TableEmailFieldsComponent implements OnInit {

    @Input('data') config;

    constructor() { }

    ngOnInit() { }

}
